import React, { useEffect, useLayoutEffect, useRef } from "react";
import UserTag from "../../shared/UserTag";
import { isMobile } from "react-device-detect";

export default ({ user, loading, setImageUrl }) => {
  const userTag = useRef(null);
  useLayoutEffect(() => {
    if (!userTag?.current || !isMobile) {
      return;
    }
    setTimeout(() => {
      const parentDom = document.querySelector("#settings .nav h1");
      if (parentDom && !parentDom.querySelector("#userTagWrapper")) {
        parentDom.appendChild(userTag?.current);
      }
    }, 1);
  }, [userTag, isMobile]);
  return (
    <div className="d-flex mt-0">
      <div
        id="userTagWrapper"
        ref={userTag}
        style={{ display: "flex", alignItems: "center", justifyContent: "center", height: isMobile ? 60 : null }}
      >
        <UserTag user={user} disabled editProfilePicture setImageUrl={setImageUrl} isVertical={isMobile} />
      </div>
      <div className="col" style={isMobile ? { height: 60, padding: 0 } : {}}>
        <input
          disabled={loading}
          name="username"
          type="text"
          className="form-control username"
          placeholder="username"
          maxLength={26}
          defaultValue={user.username}
        />
      </div>
    </div>
  );
};
